import { route } from '@md/routing';
import { clientServicesApi } from '@md/delivery/api';
import { receiveRoute } from '@sections/cabinet/components/views/utils';

const List = () => import('./views/List');
const Edit = () => import('./views/Edit');
const Create = () => import('./views/Create');

const CLIENT_SERVICES_PREFIX = 'cabinet:delivery:client-services:';
const p = name => CLIENT_SERVICES_PREFIX + name;

export const LIST = p('list');
export const EDIT = p('edit');
export const CREATE = p('create');

export function createRoutes() {
  return [
    route(
      'list/',
      List,
      LIST
    ),
    route(
      'create/',
      Create,
      CREATE
    ),
    receiveRoute(
      clientServicesApi.retrieve,
      [
        route(
          'edit/',
          Edit,
          EDIT
        ),
        {
          path: '',
          redirect: {
            name: EDIT,
          },
        },
      ]
    ),

    {
      path: '',
      redirect: {
        name: LIST,
      },
    },
  ];
}